import React, { useRef } from 'react';
import { putObject } from '@/utils/upload';
import { Button, message } from 'antd';
// import { UploadOutlined } from '@ant-design/icons';

const Upload = (props) => {
  const { buttonText, buttonType, callback, type = '' } = props;
  const inputRef = useRef(null);

  const selectFile = () => {
    inputRef.current.click();
  };
  const fileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    const file = e.target.files[0];
    const fileType = file.name.substring(file.name.lastIndexOf('.'));
    const types = type.split(',').map((item) => item.trim().toUpperCase());
    if (!types.includes(fileType.toUpperCase())) {
      message.warn('不支持此类型文件！');
      return;
    }
    const hide = message.loading('上传中。。。');
    putObject({
      filename: file.name,
      file,
      // onProgress: (data)=>{
      //   // console.log(data)
      // },
      callback: (err, data) => {
        inputRef.current.value = '';
        // console.log(data);
        hide();
        if (err) {
          message.error(err);
          return;
        }
        message.success('上传成功！');
        callback(data);
      },
    });
  };
  return (
    <>
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={fileChange}
        accept={type || '*'}
        // accept=".WMV, .RM, .MOV,.MPEG,.MP4,.3GP, .FLV, .AVI, .RMVB"
        // accept=".MP4,"
        // multiple="multiple"
      />
      <Button type={buttonType || 'link'} onClick={selectFile}>
        {buttonText || '上传'}
      </Button>
    </>
  );
};
export default Upload;
